import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IUpdateDefinitionChangeParamRequest {
  id: number;
  roleLevel: number;  
  processGroup: string;
  processType: string;
}

async function updateDefinitionChangeParam(
  data: IUpdateDefinitionChangeParamRequest
): Promise<any> {
  try {
    return (await axiosInstance.put("/DefinitionChangeParam/Update", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useUpdateDefinitionChangeParam() {
  return useMutation<any, Error, IUpdateDefinitionChangeParamRequest>(
    (variables) => updateDefinitionChangeParam(variables)
  );
}
